import httpClient from "../http/http-client";
import { ICreateReductionScenario, IReductionScenario, IReductionScenarioProject, IReductionScenarioProjectPayload } from './reduction-scenario.model';

export default class ReductionScenarioService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getReductionScenarios(): Promise<IReductionScenario[]> {
    return this.http.get('reduction-scenario')
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async createReductionScenario(values: ICreateReductionScenario): Promise<IReductionScenario> {
    return this.http.post('reduction-scenario', values)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async updateReductionScenario(id: string, values: { name?: string; description?: string | null; annualGrowthPercentage?: number | null }): Promise<IReductionScenario> {
    return this.http.patch(`reduction-scenario/${id}`, values)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async deleteReductionScenario(id: string): Promise<void> {
    return this.http.delete(`reduction-scenario/${id}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async duplicateReductionScenario(id: string): Promise<IReductionScenario> {
    return this.http.post(`reduction-scenario/${id}/duplicate`, {})
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async createScenarioProject(scenarioId: string, values: IReductionScenarioProjectPayload): Promise<IReductionScenarioProject> {
    return this.http.post(`reduction-scenario/${scenarioId}/projects`, values)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async updateScenarioProject(scenarioId: string, projectId: string, values: Partial<IReductionScenarioProjectPayload>): Promise<IReductionScenarioProject> {
    return this.http.patch(`reduction-scenario/${scenarioId}/projects/${projectId}`, values)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async deleteScenarioProject(scenarioId: string, projectId: string): Promise<void> {
    return this.http.delete(`reduction-scenario/${scenarioId}/projects/${projectId}`)
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }

  async addScenarioProjectToPlan(scenarioId: string, projectId: string, reportPeriodId: string): Promise<any> {
    return this.http.post(`reduction-scenario/${scenarioId}/projects/${projectId}/add-to-plan`, { reportPeriodId })
      .then(response => response.data)
      .catch(err => {
        console.log(err)
        throw err
      });
  }
}
